export default "__VITE_ASSET__BrYjVcYz__"